import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as WarningBlue } from 'assets/icons/green-alert.svg';
import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { Modal } from 'components';
import {
  outcomes,
} from 'utils';
import SuccessModal from '../successModal';

const ApproveModal = ({
  isApproveVisible,
  setIsApproveVisible,
  handleSubmit,
  submitDisabled,
  formKey,
  outcome,
  businessKey,
}) => {
  const user = useSelector(state => state.user);
  const isBeneficiary =
    user?.groups?.filter(a => a.id.startsWith('Beneficiary')).length > 0;
  const isUserKTP =
    user?.groups?.filter(a => a.id.startsWith('KTP')).length > 0;
  const isUserProvider =
    user?.groups?.filter(a => a.id.startsWith('ProviderResourceGroup')).length >
    0;
  const rejectBeneficiary = outcome === outcomes.rejectBeneficiary;
  const rejectAudit = outcome === outcomes.rejectAudit;
  const [successModalVisible ,setSuccessVisible] = useState(false);
  console.log("successModalVisible",successModalVisible);

  const renderContent = () => {
    {
        return (
          <div>
            <WarningBlue></WarningBlue>
            <div className="content-title-2 font-size-18 mb-2">
              Έγκριση Αίτησης
            </div>
            Πρόκειται να προχωρήσετε σε Έγκριση της Αίτησης του Επενδυτικού Σχεδίου.
            <br></br>
            <br></br>
            Παρακαλούμε επιβεβαιώστε την ενέργεια διαφορετικά επιλέξτε Ακύρωση. 
          </div>
        );
      
    }
  };

  const submit = () => {
      setIsApproveVisible(false);
      handleSubmit();
  };

  return (
    <>
      <Modal
        isVisible={isApproveVisible}
        setVisible={setIsApproveVisible}
        handleCancel={() => {
          setIsApproveVisible(false);
        }}
        handleConfirm={submit}
        cancelText={(isUserKTP || rejectBeneficiary  || rejectAudit) ? 'Επιστροφή' : 'Ακύρωση'}
        okText={
          [
            outcomes.rejectKtp,
            outcomes.approveKtp,
            outcomes.rejectBeneficiary,
            outcomes.approveBeneficiary,
            outcomes.rejectAudit,
            outcomes.approveAudit,
            outcomes.returnObjection,
          ].includes(outcome)
            ? 'Επιβεβαίωση'
            : isBeneficiary
            ? 'Υποβολή'
            : 'Επιβεβαίωση'
        }
        Icon={outcome === outcomes.rejectKtp ? WarningRed : WarningBlue}
        outcome={outcome}
        user={user}
      >
        <div className="modal-submit-content">{renderContent()}</div>
      </Modal>
      <SuccessModal isVisible={successModalVisible} setVisible={setSuccessVisible}></SuccessModal>
    </>
  );
};

export default ApproveModal;
